import { AppConfig } from '@core/config/app-config';
import { AgentOptions } from '@newrelic/browser-agent/loaders/agent';


export function buildNewRelicConfig(appConfig: AppConfig): AgentOptions {
  return {
    init: {
      distributed_tracing: { enabled: true },
      performance: { capture_measures: true },
      browser_consent_mode: { enabled: false },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] }
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: appConfig.newRelic.licenseKey,
      applicationID: appConfig.newRelic.applicationID,
      sa: 1
    },
    loader_config: {
      accountID: appConfig.newRelic.accountID,
      trustKey: appConfig.newRelic.accountID,
      agentID: appConfig.newRelic.applicationID,
      licenseKey: appConfig.newRelic.licenseKey,
      applicationID: appConfig.newRelic.applicationID
    }
  };
}
